export default "__VITE_ASSET__879debb7__"